export class CarbonModel {
    date:           string;
    timezone:       string;
    timezone_type:  number;
}

export class EventModel {
    id:         number;
    startTime:  string; // CarbonModel;
    stopTime:   string; // CarbonModel;

    constructor(event = null) {
        if (event) {
            this.id         = event.id;
            this.startTime  = event.startTime;
            this.stopTime   = event.stopTime;
        }
    }
}

export class RecordModel extends EventModel {
    recordUrl:  string;

    constructor(record = null) {
        super(record);
        if (record) {
            this.recordUrl  = record.recordUrl;
        }
    }
}

export class RecordsEventsModel {
    date:       Date;
    records:    RecordModel[];
    events:     EventModel[];

    constructor(date = null, records = null, events = null) {
        if (date) {
            this.date = date;
        } else {
            this.date = new Date();
        }
        if (records) {
            this.records = records;
        } else {
            this.records = [];
        }
        if (events) {
            this.events = events;
        } else {
            this.events = [];
        }
    }
}

export class DateModel {
    date:       string;

    constructor(date = null) {
        if (date) {
            this.date = date;
        } else {
            this.date = '';
        }
    }
}
